exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#diagram3a2-4 #slots .fixed-answer,#diagram3a2-4 .element{border:2px solid #fff;background:transparent;height:90px}#diagram3a2-4 #slots .fixed-answer:focus,#diagram3a2-4 #slots .fixed-answer:hover,#diagram3a2-4 .element:focus,#diagram3a2-4 .element:hover{z-index:100;background:#a7dec3}#diagram3a2-4 #slots .answer-field,#diagram3a2-4 #slots div[id]{height:90px}#diagram3a2-4 .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#a7dec3;border-radius:10px;padding:5px 10px 3px;color:#fff;cursor:pointer;outline:none;text-decoration:none}#diagram3a2-4 .diagram-task{float:left;width:100%;text-align:left;text-shadow:none;letter-spacing:1px;font-family:Nexa-Bold,sans pro,\"serif\";font-size:20px;padding-bottom:70px;padding-left:5px}#diagram3a2-4 #slots .hint{position:absolute;top:-15px;right:90px;border:2px solid #a7dec3;background:#a7dec3;transition:all .4s;opacity:1;z-index:3;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/3/3a2/diagram4/diagram4.scss
// module id = 1127
// module chunks = 0